import React from "react";
import BaseIcon from "../../utils/BaseIcon";

var ChevronUpSystemIcon = function ChevronUpSystemIcon(props) {
  var iconFill = "currentColor";
  return /*#__PURE__*/React.createElement(BaseIcon, props, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: iconFill,
    fillRule: "nonzero",
    d: "M12.032 7.506l-10.62 10.62a.75.75 0 01-1.06-1.06l11.15-11.15a.75.75 0 011.06 0l11.15 11.15a.75.75 0 01-1.06 1.06l-10.62-10.62z"
  })));
};

ChevronUpSystemIcon.displayName = "ChevronUpSystemIcon";
ChevronUpSystemIcon.defaultProps = {
  size: 24
};
ChevronUpSystemIcon.displayName = "ChevronUpSystemIcon";
ChevronUpSystemIcon.iconName = "ChevronUp";
export default ChevronUpSystemIcon;